/** iOS-style row swipe: width of revealed action strip (px). */
export const SWIPE_ACTION_WIDTH_PX = 72;
/** Past this offset (px), row snaps fully open on release. */
export const SWIPE_SNAP_OPEN_PX = 40;
/** Movement (px) before axis is locked for horizontal vs vertical scroll. */
export const SWIPE_DIRECTION_LOCK_PX = 10;

export function clampSwipeOffset(
  offset: number,
  canEdit: boolean,
  canDelete: boolean,
  width: number
): number {
  const min = canDelete ? -width : 0;
  const max = canEdit ? width : 0;
  return Math.max(min, Math.min(max, offset));
}

export function computeSnappedOffset(
  off: number,
  canEdit: boolean,
  canDelete: boolean,
  width: number
): number {
  if (off >= SWIPE_SNAP_OPEN_PX && canEdit) return width;
  if (off <= -SWIPE_SNAP_OPEN_PX && canDelete) return -width;
  return 0;
}

/**
 * Asymmetric variant: rows whose left strip (revealed by swiping right) and right strip
 * (revealed by swiping left) hold a different number of actions. Pass `0` to disable a side.
 */
export function clampSwipeOffsetAsymmetric(
  offset: number,
  leftStripWidth: number,
  rightStripWidth: number
): number {
  const min = rightStripWidth > 0 ? -rightStripWidth : 0;
  const max = leftStripWidth > 0 ? leftStripWidth : 0;
  return Math.max(min, Math.min(max, offset));
}

export function computeSnappedOffsetAsymmetric(
  off: number,
  leftStripWidth: number,
  rightStripWidth: number
): number {
  if (off >= SWIPE_SNAP_OPEN_PX && leftStripWidth > 0) return leftStripWidth;
  if (off <= -SWIPE_SNAP_OPEN_PX && rightStripWidth > 0) return -rightStripWidth;
  return 0;
}
